var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.emailSubmitted
        ? _c("p", {
            staticClass: "ui-body",
            domProps: { innerHTML: _vm._s(_vm.registerSuccessBody) },
          })
        : _vm.userExists
        ? _c("div", [
            _c("h4", [_vm._v("Your email address is already registered")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("Click "),
                _c("router-link", { attrs: { to: { name: "Login" } } }, [
                  _vm._v("here"),
                ]),
                _vm._v(" to login or reset your password."),
              ],
              1
            ),
          ])
        : [
            _c("p", { staticClass: "ui-title" }, [
              _vm._v(_vm._s(_vm.registerHeading)),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "ui-body",
              domProps: { innerHTML: _vm._s(_vm.registerBodyComputed) },
            }),
            _vm._v(" "),
            _c(
              "ui-form",
              {
                attrs: {
                  "is-processing": _vm.isProcessing,
                  valid: _vm.formValid,
                },
                on: {
                  "update:valid": function ($event) {
                    _vm.formValid = $event
                  },
                  submit: _vm.register,
                },
              },
              [
                !_vm.params.token
                  ? _c("ui-input", {
                      attrs: { label: "E-mail", required: "", type: "email" },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.partner || (_vm.params.token && !_vm.params.fname)
                  ? _c("ui-input", {
                      attrs: {
                        label: "First name",
                        required: _vm.params.token,
                        type: "text",
                      },
                      model: {
                        value: _vm.firstName,
                        callback: function ($$v) {
                          _vm.firstName = $$v
                        },
                        expression: "firstName",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.partner || (_vm.params.token && !_vm.params.lname)
                  ? _c("ui-input", {
                      attrs: {
                        label: "Last name",
                        required: _vm.params.token,
                        type: "text",
                      },
                      model: {
                        value: _vm.lastName,
                        callback: function ($$v) {
                          _vm.lastName = $$v
                        },
                        expression: "lastName",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.params.token
                  ? _c("ui-input", {
                      attrs: {
                        autocomplete: "new-password",
                        label: "Password",
                        minlength: "8",
                        required: "",
                        type: "password",
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.params.token
                  ? _c("ui-input", {
                      attrs: {
                        error: _vm.passwordMatch,
                        autocomplete: "new-password",
                        label: "Verify password",
                        required: "",
                        type: "password",
                      },
                      model: {
                        value: _vm.verifyPassword,
                        callback: function ($$v) {
                          _vm.verifyPassword = $$v
                        },
                        expression: "verifyPassword",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.partner || (_vm.params.token && !_vm.params.company_name)
                  ? _c("ui-input", {
                      attrs: {
                        label: "Company",
                        required: _vm.params.token,
                        type: "text",
                      },
                      model: {
                        value: _vm.companyName,
                        callback: function ($$v) {
                          _vm.companyName = $$v
                        },
                        expression: "companyName",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.partner || (_vm.params.token && !_vm.params.pop_id)
                  ? _c(
                      "ui-select",
                      {
                        attrs: {
                          label: "Recorder/storage location",
                          required: _vm.params.token,
                        },
                        model: {
                          value: _vm.popId,
                          callback: function ($$v) {
                            _vm.popId = $$v
                          },
                          expression: "popId",
                        },
                      },
                      _vm._l(_vm.popIdList, function (val, key) {
                        return _c("ui-select-item", {
                          key: key,
                          attrs: { label: val, value: key },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui-layout ui-alignment-center-space-between",
                  },
                  [
                    _vm.privacyUrl
                      ? _c("div", [
                          _vm._v(
                            "Your privacy is important to us. By submitting your information you are agreeing to our "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: _vm.privacyUrl, target: "_blank" },
                            },
                            [_vm._v("Privacy notice")]
                          ),
                          _vm._v("."),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: { name: "Login" } } }, [
                      _vm._v("Already registered? Login"),
                    ]),
                    _vm._v(" "),
                    _c("ui-button", {
                      attrs: {
                        disabled: !_vm.formValid || _vm.isProcessing,
                        primary: "",
                        raised: "",
                        text: "Register",
                        type: "submit",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }